import service, { HttpResponseSuccess } from '@/services/service';

const apiClient = service(`${process.env.REACT_BACKEND_HOST}`);

export interface OnboardingListPayload {
	targetAudience: string;
	offering: string;
}

export interface OnboardingListResponse {
	listId: string;
	listName: string;
	selectedBusinessCount: number;
	totalBusinessCount: number;
}

export const ONBOARDING_LIST_QUERY_KEY = ['onboardingList'];

export const generateOnboardingList = (
	payload: OnboardingListPayload
): Promise<HttpResponseSuccess<OnboardingListResponse>> =>
	apiClient.post('/api/list/ai/generate', payload);
